
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 17","xmlns":"http://www.w3.org/2000/svg","aria-labelledby":"title"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.5 9a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm4.232.013l4.008 4.314a1 1 0 11-1.465 1.361l-4.081-4.392a5.5 5.5 0 111.538-1.283z","fill":"#fff"}})])
          )
        }
      }
    